export default __webpack_public_path__ + "static/media/plate.372e7641.png";